import VueSignature from './components/vueSignature.vue'
export default VueSignature


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-signature/src/main.js
// module id = lxyI
// module chunks = 1